import { Rental, TenantExpired } from "@/types/rental.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useTranslation } from "react-i18next";

export default function TableHeaderExired(): ColumnDef<TenantExpired>[] {
    const {t} = useTranslation();

    return [
        {
            header: t("rental.business_unit"),
            accessorKey: "business_unit_name",
            enableSorting: false
        },
        {
            header: t("rental.name"),
            accessorKey: "tenant_name",
            enableSorting: false
        },
        {
            header: t("tenant.fin_expiry"),
            accessorKey: "fin_expiry",
            enableSorting: false,
            cell: ({row}) => formatDateTimeAutoToString(row.original.fin_expiry ?? '', "ll")
        }
    ]
}
